<template>
  <div class="proxy-history">
    <!-- 交易类型筛选 -->
    <van-tabs
      v-model:active="activeTab"
      class="transaction-tabs"
      @change="handleTabChange"
    >
      <van-tab title="全部" />
      <van-tab title="待收货" :badge="receiptCnt"/>
      <van-tab title="已完成" />
      <van-tab title="已取消" />
      <van-tab title="交易失败" />
    </van-tabs>
    <!-- 交易记录列表 -->
    <div class="order-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多记录"
          @load="onLoad"
        >
          <!-- <div
              v-for="item in list"
              :key="item.orderId"
              class="order-item"
              @click="viewDetail(item)"
            >
              <div class="order-header">
                <div class="order-info">
                  <span class="order-id">订单号:{{ item.orderNo }}</span>
                  <span class="order-time">{{ item.createdAt }}</span>
                </div>
                <div>
                  <van-button @click.stop="handleContact" type="success" icon="service-o" size="mini">联系我们</van-button>
                  </div>
              </div>
              <div class="order-content">
               
                <div class="order-details">
                  <div class="detail-row">
                    <span class="label">饰品：</span>
                    <van-image :src="item.imageUrl" fit="contain" width="50px"/>
                  </div>
                  <div class="detail-row">
                    <span class="label">贴纸：</span>
                    <div class="icons-container" v-if="item.stickerUrls&&item.stickerUrls.length>0">
                      <img 
                          v-for="(sticker, index) in item.stickerUrls.split(',')" 
                          :key="index"
                          :src="sticker" 
                          :alt="item.categoryName"
                          class="icon-item"
                          :title="item.categoryName"
                        />
                    </div>
                    <div v-else>无</div>
                  </div>
                  <div class="detail-row">
                    <span class="label">交易金额：</span>
                    <span class="price" :class="item.amountClass">￥{{ item.amount }} </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">状态：</span>
                    <span class="value" v-if="item.status==0">待收货</span>
                    <span class="value" v-if="item.status==1">已完成</span>
                    <span class="value" v-if="item.status==2">已取消</span>
                    <span class="value" v-if="item.status==3">交易失败</span>
                  </div>
                  
                </div>
              </div>
            </div> -->
          <div
            v-for="item in list"
            :key="item.orderId"
            class="order-item"
            @click="viewDetail(item)"
          >
            <div class="order-header">
              <div class="order-info">
                <span class="order-id">订单号: {{ item.orderNo }}</span>
                <span class="order-time">{{ item.createdAt }}</span>
              </div>
              <van-button
                @click.stop="handleContact"
                type="success"
                icon="service-o"
                size="normal"
                style="height: 30px"
                >联系我们</van-button
              >
            </div>

            <div class="order-content">
              <!-- 左侧：武器图标 -->
              <div class="weapon-image">
                <van-image
                  :src="item.imageUrl"
                  fit="contain"
                  width="90px"
                  height="60px"
                />
                <img
                  v-if="item.isStack == '1'"
                  src="@/assets/st.png"
                  alt="ST"
                  width="26px"
                  height="16px"
                  class="product-sales"
                />
                <div class="template-wrapper" v-if="item.template > 0">
                  <img src="@/assets/template.png" width="25px" height="25px" />
                  <span class="template">{{ item.template || "0" }}</span>
                </div>
              </div>

              <!-- 右侧：内容区域 -->
              <div class="content-wrapper">
                <div class="weapon-name">{{ item.categoryName }}</div>
                <div class="price">￥{{ item.amount }}</div>

                <!-- 贴纸图标 -->
                <div
                  class="stickers-container"
                  v-if="item.stickerUrls && item.stickerUrls.length > 0"
                >
                  <img
                    v-for="(sticker, index) in item.stickerUrls.split(',')"
                    :key="index"
                    :src="sticker"
                    :alt="item.categoryName"
                    class="sticker-icon"
                  />
                </div>

                <!-- 状态 -->
                <div class="status">
                  <span v-if="item.status == 1" class="status-failed"
                    >待收货</span
                  >
                  <span v-if="item.status == 3" class="status-failed"
                    >已取消</span
                  >
                  <span v-if="item.status == 4" class="status-success"
                    >已完成</span
                  >
                  <span v-if="item.status == 6" class="status-failed"
                    >交易失败</span
                  >
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <!-- <div class="contact-button" @click="handleContact">
          <van-icon name="service-o" size="24" />
          <span>联系我们</span>
        </div> -->
    </div>
    <!-- 空状态 -->
    <!-- <van-empty
        v-if="!loading && filteredTransactions.length === 0"
        image="search"
        description="暂无交易记录"
      /> -->
    <!-- 详情弹窗 -->
    <van-popup
      v-model:show="showDetail"
      position="bottom"
      :style="{ height: '50%' }"
      round
    >
      <div class="detail-popup">
        <div class="detail-header">
          <h3>交易详情</h3>
          <van-icon name="cross" @click="showDetail = false" />
        </div>
        <div v-if="selectedItem" class="detail-content">
          <div class="detail-section">
            <van-cell title="订单号" :value="selectedItem.orderNo" />
            <van-cell title="交易金额" :value="selectedItem.amount + ' '" />
            <van-cell title="时间" :value="selectedItem.createdAt" />
            <van-cell title="状态">
              <template #value>
              
                <span class="value" v-if="selectedItem.status == 1"
                  >待收货</span
                >
              
                <span class="value" v-if="selectedItem.status == 3"
                  >已取消</span
                >
                 <span class="value" v-if="selectedItem.status == 4"
                  >已完成</span
                >
              
                <span class="value" v-if="selectedItem.status == 6"
                  >交易失败</span
                >
              </template>
            </van-cell>
            <van-cell title="订单凭证">
              <template #value>
                <van-image
                  :src="selectedItem.orderField1"
                  fit="contain"
                  alt="订单凭证"
                  width="50px"
                  height="50px"
                />
              </template>
            </van-cell>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- <van-popup v-model:show="showQywxCode" position="center" :style="{ height: '80%' }" >
    <div >
        <van-image  fit="contain" :src="weChatUrl" /> 
        <h2 style="text-align: center;">请您加一下我们的官方企业微信,进行交流</h2>
    </div>
  </van-popup> -->
  </div>
</template>

<script>
import { showToast } from "vant";
import request from "@/utils/request";
import companyUrl from "@/assets/qywx2.png";
export default {
  data() {
    return {
      activeTab: 0,
      transactions: [],
      list: [],
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      receiptCnt: 0,
      refreshing: false,
      showDetail: false,
      showQywxCode: false,
      selectedItem: null,
      zijinForm: {},
      //购买记录 1
      tranType: 1,
      weChatUrl: companyUrl,
    };
  },
  created() {
     this.page = 1
     this.getList()
  },
  methods: {
    getList() {
      if (this.finished) {
        return false;
      }
      let status = "";
      if (this.activeTab == 1) {
        status = 1;
      } else if (this.activeTab == 2) {
        status = 4;
      } else if (this.activeTab == 3) {
        status = 3;
      } else if (this.activeTab == 4) {
        status = 6;
      }
      request
        .get("/front/weapon/query", {
          params: {
            pageNum: this.page,
            pageSize: 10,
            status: status,
            categoryName: this.zijinForm.categoryName,
            orderNo: this.zijinForm.orderNo,
            tranType: this.tranType,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (this.page === 1) {
              this.list = res.rows;
            } else {
              this.list = [...this.list, ...res.rows];
            }
            if (status == 1 || status == "") {
this.receiptCnt = this.list.filter(item => item.status == 1).length;
            }
            // 判断是否还有更多数据
            this.finished = this.list.length >= res.total;
          } else {
            this.finished = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onLoad() {
      setTimeout(() => {
        this.page++;
        this.getList();
      }, 500);
    },
    onRefresh() {
      this.refreshing = true;
      setTimeout(() => {
        this.list = [];
        this.page = 1;
        this.finished = false;
        this.getList();
        this.refreshing = false;
      }, 500);
    },
    handleContact() {
      // this.showQywxCode = true
      //改成采用企业微信直接打开的方式
      window.open("https://work.weixin.qq.com/kfid/kfc0afede0891281246");
    },

    handleTabChange(tabIndex) {
      console.log(tabIndex);
      this.activeTab = tabIndex;
      this.page = 1;
      this.finished = false; // 重置加载完成状态
      this.list = []; // 清空当前列表
      this.getList();
    },
    viewDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
  },
};
</script>

<style scoped>
.proxy-history {
  background-color: #f7f8fa;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.order-list {
  padding: 16px;
  overflow-y: scroll;
  min-height: 0;
}
.order-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}
.order-item:active {
  transform: scale(0.98);
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.order-info {
  flex: 1;
}
.order-id {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
  display: block;
  margin-bottom: 4px;
}
.order-time {
  font-size: 12px;
  color: #969799;
}
.order-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.status-success {
  color: #07c160;
}
.status-failed {
  color: #f53f3f;
}
.order-content {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}
.order-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-details {
  flex: 1;
}
.detail-row {
  display: flex;
  margin-bottom: 6px;
  font-size: 14px;
}
.detail-row:last-child {
  margin-bottom: 0;
}
.label {
  color: #646566;
  width: 80px;
  flex-shrink: 0;
}
.value {
  color: #323233;
  flex: 1;
}
.price-row .price {
  color: #ee0a24;
  font-weight: 600;
}
/* 详情弹窗样式 */
.detail-popup {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebedf0;
}
.detail-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}
.detail-section {
  margin-bottom: 24px;
}
.contact-button {
  position: fixed;
  right: 16px;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1989fa;
  color: white;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 99;
}

.contact-button span {
  font-size: 12px;
  margin-top: 4px;
}

.contact-button:active {
  opacity: 0.8;
}
/* 左下角图标容器 */
/* .icons-container {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  gap: 5px;
} */

.icon-item {
  width: 14px;
  height: 14px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  margin-top: 2px;
  object-fit: cover;
}

.order-item {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.order-info {
  flex: 1;
}

.order-id {
  font-size: 14px;
  font-weight: 500;
  color: #323233;
  display: block;
  margin-bottom: 4px;
}

.order-time {
  font-size: 12px;
  color: #969799;
}

.order-content {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  position: relative;
}

.weapon-image {
  flex-shrink: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 10px;
  position: relative;
}

.weapon-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 4px;
}

.price {
  font-size: 18px;
  color: #ee0a24;
  font-weight: bold;
  margin-bottom: 8px;
}

.stickers-container {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}

.sticker-icon {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 2px;
}

.status {
  position: absolute;
  bottom: -14px;
  right: 10px;
  font-size: 20px;
  font-weight: 500;
}

.status-success {
  color: #07c160;
}

.status-pending {
  color: #ff9800;
}

.status-cancelled {
  color: #f53f3f;
}

.status-failed {
  color: #f53f3f;
}

.product-sales {
  position: absolute;
  left: 0px;
  top: 0px;
}

.template-wrapper {
  position: absolute;
  bottom: 3px;
  left: 0px;
  display: inline-flex;
  align-items: center;
}
.template {
  position: absolute;
  left: 50%;
  top: 60%;
  transform: translate(-50%, -50%);
  color: #eee;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}
</style>
